<template>
  <div>
    <div class="text-right">
      <el-button type="primary" size="mini" @click="dialogVisible = true">
        Create Distributor
      </el-button>
    </div>
    <el-dialog title="Create Distributor" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
        <el-form-item label="Distributor name" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="Country" prop="country_id">
          <app-countries v-model="form.country_id" />
        </el-form-item>
        <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
        <el-button @click="onCancel('form')">Cancel</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import AppCountries from '@/components/App/AppCountries'

export default {
  components: {
    AppCountries,
  },

  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        country_id: null,
        name: null,
      },
      rules: {
        'country_id': [
          { required: true, message: 'Select the distributor country.', trigger: 'blur' },
        ],
        'name': [
          { required: true, message: 'Enter the distributor name.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          this.loading = false
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.post(`/distributors`, {
            country_id: this.form.country_id,
            name: this.form.name,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$router.push({ name: 'distributors-id', params: { id: data.distributor.id } })
        this.$message.success(data.message)
      })
    },

    onCancel(form) {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>
